module.exports = __webpack_public_path__ + "static/media/City-University-London.eed6185f.png";